// modules
import { createAction } from 'redux-actions'

// actions
export const setUrgentCareReportList = createAction(
  'SET_URGENT_CARE_REPORT_LIST'
)
